import { useCallback, useState } from 'react';
import { useLang } from 'hooks/lang';

import { AddCountryRequest as AddCountryRequestType } from 'entities';

import { Column, Select, Row, Label } from 'components/Blocks';

import { SingleCountry } from './SingleCountry';

import { useProjectUpdate } from 'providers/Project';
import { useLocalPendingEntries } from 'providers/PendingActions';

export function AddCountryRequest() {
  const updateProject = useProjectUpdate();

  const { t } = useLang();

  const addCountryProjects = useLocalPendingEntries('ADD_COUNTRY_TO_PROJECT');

  const [focusedProject, setFocusedProject] = useState(addCountryProjects[0]?.id || '');

  const removeProject = useCallback(
    (projectId: string) => {
      const [nextProject] = addCountryProjects.filter(({ id }) => projectId !== id);
      setFocusedProject(nextProject?.id || '');

      updateProject(projectId, (old) => ({
        ...old,

        addCountryRequest: {
          ...old.addCountryRequest,
          status: 'WAITING_APPROVAL',
        } as AddCountryRequestType,
      }));
    },
    [updateProject, addCountryProjects],
  );

  if (!addCountryProjects.length)
    return (
      <div>
        <h6 className="text-center">{t('there-are-no-requests-to-add-country')}</h6>
      </div>
    );

  const selectedProject = addCountryProjects.find(({ id }) => focusedProject === id);

  return (
    <Column>
      <Row justifyContent="space-between">
        <Label>{t('view-requests')}</Label>

        <Select
          id="add-country-requests"
          options={addCountryProjects}
          value={focusedProject}
          onChangeDirect={setFocusedProject}
          isSearchable
          labelKey="name"
          containerClassName="max-w-[350px] w-full"
        />
      </Row>

      {!!selectedProject && (
        <SingleCountry
          key={`add-country-${selectedProject.id}`}
          project={selectedProject}
          removeSelf={() => removeProject(selectedProject.id)}
        />
      )}
    </Column>
  );
}
